import { Breadcrumb } from "antd";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import React, { useMemo } from "react";
import { trailIfTooLong } from "../../utils/misc/strings";

type Props = {
  pageName:
    | "events"
    | "event"
    | "newEvent"
    | "action"
    | "newAction"
    | "audit"
    | "newAudit"
    | "constat"
    | "newConstat"
    | "constatAction"
    | "newConstatAction"
    | "project"
    | "newProject"
    | "projectAction"
    | "newProjectAction";
  eventId?: number;
  eventName?: string | null;
  actionId?: number;
  actionName?: string | null;
  auditId?: number;
  auditName?: string | null;
  constatId?: number;
  constatName?: string | null;
  projectId?: number;
  projectName?: string | null;
};

const Breadcrumbs: React.FC<Props> = ({
  pageName,
  eventName,
  eventId,
  actionName,
  actionId,
  auditName,
  auditId,
  constatName,
  constatId,
  projectName,
  projectId,
}) => {
  const breadcrumbItems = useMemo(() => {
    const items: ItemType[] = [
      {
        href: "/",
        title: "Tableau de bord",
        className: "text-light-blue",
      },
    ];

    if (pageName === "event") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
      });
    }

    if (pageName === "action") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: trailIfTooLong(actionName) || `#${actionId}`,
        href: `/events/${eventId}/actions/${actionId}`,
        className: "text-bold-black",
      });
    }

    if (pageName === "newEvent") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: "/events/new",
        title: "Nouvel Ã©vÃ©nement",
      });
    }

    if (pageName === "newAction") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: "Nouvelle action",
        href: `/events/${eventId}/actions/new`,
      });
    }
    if (pageName === "audit") {
      items.push({
        href: "/audits",
        title: "Audits",
        className: "text-light-blue",
      });
      items.push({
        href: `/audits/${auditId}`,
        title: trailIfTooLong(auditName) || `#${auditId}`,
      });
    }

    if (pageName === "newAudit") {
      items.push({
        href: "/audits",
        title: "Audits",
        className: "text-light-blue",
      });
      items.push({
        href: "/audits/new",
        title: "Nouvel audit",
      });
    }

    if (pageName === "constat") {
      items.push({
        href: "/pdca/constat",
        title: "Constats",
        className: "text-light-blue",
      });
      items.push({
        href: `/constats/${constatId}`,
        title: trailIfTooLong(constatName) || `#${constatId}`,
      });
    }

    if (pageName === "newConstat") {
      items.push({
        href: "/pdca/constat",
        title: "Constats",
        className: "text-light-blue",
      });
      items.push({
        href: "/constats/new",
        title: "Nouveau constat",
      });
    }

    if (pageName === "constatAction") {
      items.push({
        href: "/pdca/constat",
        title: "Constats",
        className: "text-light-blue",
      });
      items.push({
        href: `/constats/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/constats/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: trailIfTooLong(actionName) || `#${actionId}`,
        href: `/constats/${eventId}/actions/${actionId}`,
        className: "text-bold-black",
      });
    }

    if (pageName === "newConstatAction") {
      items.push({
        href: "/pdca/constat",
        title: "Constats",
        className: "text-light-blue",
      });
      items.push({
        href: `/constats/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/constats/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: "Nouvelle action",
        href: `/constats/${eventId}/actions/new`,
      });
    }

    if (pageName === "project") {
      items.push({
        href: "/pdca/projets",
        title: "Projets",
        className: "text-light-blue",
      });
      items.push({
        href: `/projects/${projectId}`,
        title: trailIfTooLong(projectName) || `#${projectId}`,
      });
    }

    if (pageName === "newProject") {
      items.push({
        href: "/pdca/projets",
        title: "Projets",
        className: "text-light-blue",
      });
      items.push({
        href: "/projects/new",
        title: "Nouveau projet",
      });
    }

    if (pageName === "projectAction") {
      items.push({
        href: "/pdca/projets",
        title: "Projets",
        className: "text-light-blue",
      });
      items.push({
        href: `/projects/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/projects/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: trailIfTooLong(actionName) || `#${actionId}`,
        href: `/projects/${eventId}/actions/${actionId}`,
        className: "text-bold-black",
      });
    }

    if (pageName === "newProjectAction") {
      items.push({
        href: "/pdca/projets",
        title: "Projets",
        className: "text-light-blue",
      });
      items.push({
        href: `/projects/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/projects/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: "Nouvelle action",
        href: `/projects/${eventId}/actions/new`,
      });
    }

    return items;
  }, [
    pageName,
    eventId,
    eventName,
    actionName,
    actionId,
    auditId,
    auditName,
    constatId,
    constatName,
    projectId,
    projectName,
  ]);

  return (
    <Breadcrumb
      separator=">"
      style={{ margin: "16px 0" }}
      items={breadcrumbItems}
    />
  );
};

export default Breadcrumbs;
